import { render } from "./Rulesets.vue?vue&type=template&id=af1e99d6"
import script from "./Rulesets.vue?vue&type=script&lang=js"
export * from "./Rulesets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/rules/Rulesets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af1e99d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af1e99d6', __exports__)) {
    api.reload('af1e99d6', __exports__)
  }
  
  module.hot.accept("./Rulesets.vue?vue&type=template&id=af1e99d6", () => {
    api.rerender('af1e99d6', render)
  })

}


export default __exports__